export enum CategoriaDefensorEnum {
  PRIMEIRA_CATEGORIA = 'PRIMEIRA_CATEGORIA',
  SEGUNDA_CATEGORIA = 'SEGUNDA_CATEGORIA',
  SUBSTITUTO = 'SUBSTITUTO',
  SUBSTITUTO_INGRESSO = 'SUBSTITUTO_INGRESSO',
}

export const CategoriaDefensorList: Array<{ value: CategoriaDefensorEnum; label: string }> = [
  { value: CategoriaDefensorEnum.PRIMEIRA_CATEGORIA, label: '1ª Categoria' },
  { value: CategoriaDefensorEnum.SEGUNDA_CATEGORIA, label: '2ª Categoria' },
  { value: CategoriaDefensorEnum.SUBSTITUTO, label: 'Substituto' },
  { value: CategoriaDefensorEnum.SUBSTITUTO_INGRESSO, label: 'Substituto Ingresso' },
];

